export const ARTICLES_PER_PAGE = 6;
